
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUserGoogle as ObiUserGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-user-google.js';
 
 
 

 
 export const ObiUserGoogle = createComponent({
   react: React,
   tagName: 'obi-user-google',
   elementClass: ObiUserGoogleElement,
   events: {
     
   }
  });
 
 